/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Fade, Container, Paper } from '@mui/material';
import Grid from '@mui/material/Grid';
// Wimss context
import {
  useWimssController,
  setIsMobile,
  setCurrentPage,
  setCurrentTexts,
} from 'context';
import { initTexts } from 'utils/syncState';

//import hero pictures and background images
import ScheduleBanner from 'assets/images/pictures/schedule-banner.png';
import BlueSky from 'assets/images/pictures/bluesky.png';
import SandyBeach from 'assets/images/pictures/sandy-beach.png';

import WimssTabs from 'layouts/WimssTabs';

//import Schedules page text items
import { ActivityTabsList } from 'assets/web-contents/TextItems';
import EventCalendar from 'pages/components/EventCalendar';

const ScheduleHero = () => {
  return (
    <Box
      sx={{
        //   mt: 15,
        backgroundImage: `url(${ScheduleBanner})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% auto',
        overflow: 'hidden',
        overflowY: 'auto',
        width: '100vw',
        height: '100%',
        position: 'relative',
      }}>
      <Fade
        in={true}
        style={{
          transitionDelay: 500,
        }}>
        <img
          src={ScheduleBanner}
          alt={'Schedule Banner'}
          style={{
            width: '100%',
            height: 'auto',
            objectFit: 'cover',
          }}
        />
      </Fade>
    </Box>
  );
};

const Schedules = () => {
  const [controller, dispatch] = useWimssController();
  const { currentLanguage, isMobile, currentPage, currentTexts } = controller;

  const Page = 'schedules';
  const { innerWidth: width } = window;
  const navigate = useNavigate();
  const [refreshActBtn, setRefreshActBtn] = useState(true);

  useEffect(() => {
    if (width <= 600) {
      setIsMobile(dispatch, true);
    } else setIsMobile(dispatch, false);
    setCurrentPage(dispatch, Page);
  }, []);

  useEffect(() => {
    // initHero(isMobile);
  }, [isMobile]);

  useEffect(() => {
    if (currentLanguage !== '') {
      setRefreshActBtn(false);
    }

    //set pageTexts
    let pageTxts = initTexts(currentLanguage, currentPage);
    setCurrentTexts(dispatch, pageTxts);
  }, [currentLanguage, currentPage]);

  useEffect(() => {
    if (currentTexts !== null && !refreshActBtn) setRefreshActBtn(true);
  }, [currentTexts]);

  return (
    <Box sx={{ flexGrow: 1, mt: 0 }}>
      {currentTexts !== null && (
        <Grid container direction='column' spacing={{ xs: 3, md: 4 }}>
          <Grid size={12}>
            <ScheduleHero />
          </Grid>
        </Grid>
      )}
      {currentTexts !== null && refreshActBtn && (
        <Paper
          sx={{
            backgroundImage: `url(${BlueSky})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'repeat-Y',
            overflowY: 'auto',
            width: '100vw',
            height: '100%',

            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            mt: -1,
          }}>
          <Container maxWidth='lg' sx={{ mt: isMobile ? 0 : 0, py: 8 }}>
            <EventCalendar />
          </Container>
        </Paper>
      )}
      <Box
        sx={{
          backgroundImage: `url(${SandyBeach})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'repeat-Y',
          overflowY: 'auto',
          width: '100vw',
          height: 300,

          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}></Box>
    </Box>
  );
};

export default Schedules;
